const Form091SC = {
    stepName: {
        importantNotes: "重要事项",
        applicationInformation: "申请人资料",
        declaration: "确认页面",
    },
    noteList: {
        note1: "申请资助为资优学生提供校外进阶学习课程（{{schoolyear}} 学年）",
        note2: "注意事项：",
        note3: '在填写本申请表格前，请先细阅《申请指引》（<a style="color: blue" href="https://www.edb.gov.hk/en/curriculum-development/curriculum-area/gifted/ge_fund/gef/asp.html" target="_blank" rel="noopener noreferrer">https://www.edb.gov.hk/en/curriculum-development/curriculum-area/gifted/ge_fund/gef/asp.html</a>）。',
        note4: "每个课程应填写一份申请表格，每间机构可递交多于一份申请。",
        note5: "备注：",
        note6: "请于{{deadline}}，",
        note7: "将本申请表格连同课程建议书提交资优教育基金秘书处。",
        note8: "上载文件：",
        note8_1: "填妥的申请表格连同课程建议书的正本一份",
        note8_2:
            "申请机构的相关注册文件复本（例如：商业登记证）或根据《税务条例》第 88 条获豁免缴税（如适用）",
        number1: "1.",
        number2: "2.",
        number3: "3.",
        number4: "4.",
        number5: "5.",
        number6: "6.",
        number7: "7.",
        tooltip: "例如：专上院校学系／学院的主管或机构的主席／执行董事",
        tooltip_totalMonths:
            "此项数值由 （甲） 筹备课程 与 （乙） 推行课程之和自动计算所得。",
        tooltip_totalGrantSought:
            "此项数值由乙部及丙部财政预算的申请资助总额自动计算所得。",
        iamStatement:
            "本人理解申请人和申请机构审批人需要拥有「智方便+」帐户才能处理申请。",
        additionNotice_1: "请自行列印PDF档以供机构主管签署及／或协办机构盖印。",
    },
    label: {
        partA: "甲部：课程资料",
        titleOfProgramme: "课程名称",
        english: "（英文）",
        chinese: "（中文）",
        themeOfProgramme: "课程主题",
        theme: "主题",
        pleaseSpecify: "请说明",
        openBracket: "（",
        closeBracket: "）",
        underline: "_____________",
        targetBeneficiary: "受惠对象",
        target: "对象",
        targetPrefer: "（建议约50位学生；例如：50位中一至中二年级的学生）",
        targetBeneficiaryNumber: "（甲）学生人数",
        targetBeneficiaryLevel: "（乙）学生级别",
        programmePeriod: "课程所需时间：",
        months: "个月",
        preparation: "（甲）筹备课程（3个月）",
        preparation1: "（甲）筹备课程",
        preparation2: "（3个月）",
        delivery: "（乙）推行课程（不超过5个月）： ",
        delivery1: "（乙）推行课程",
        delivery2: "（不超过5个月）： ",
        total: "（丙）共：",
        closeSquareBracket: "月（建议6至15个月）",
        grantSought: "申请资助金额：合共港币＄",
        particularsOfOrganisation: "机构资料：",
        applicantOrganisation: "主办机构",
        supportingOrganisation: "协办机构（如有）",
        supportingOrganisations: "协办机构",
        name: "机构名称",
        headOfOrganisation: "机构主管",
        postTitle: "主管职衔",
        address: "机构地址",
        programmeLeader: "课程负责人资料：",
        nameAndPost: "姓名",
        post: "职衔",
        telephoneNumber: "联络电话",
        officeHours: "（办公时间）",
        outsideOfficeHours: "（非办公时间）",
        emailAddress: "电邮地址",
        emailMain: "（主要电邮）",
        emailBackup: "（备用电邮）",
        faxNumber: "传真号码",
        partB: "乙部：课程建议书摘要",
        provideSummary:
            "请就以下项目提供课程建议书的摘要，内容限于一页A4纸，字型不小于12点。",
        goal: "目标和目的",
        selection:
            "甄选资优学生参加课程的机制（例如：学生在申请表上所填报的资料／笔试／会面）",
        mechanism: "机制",
        implementation1: "课程推行：",
        implementation2: "主要筹备工作（例如：人力资源安排、准备学习资源）",
        implementation3:
            "课程概述（例如：第一阶段学习有关气象学和计算机编程的基础知识和技能；第二阶段就进阶课题进行深入学习；第三阶段进行为期3个月在良师启导下的独立专题研习；第四阶段在公开活动展示学生的学习成果）",
        implementation4:
            "师生会面时间和频次（例如：9个月［每星期3小时课堂／会面］）",
        implementation5:
            "人力资源及员工聘请（例如：聘请1名全职课程助理以协助处理课程的行政工作）",
        implementation6:
            "与其他团体／机构进行协作（例如：与一个本地专业团体合作）",
        description: "概述",
        grantSoughtAndExpenditure: "申请资助金额及开支项目（港币＄）：",
        staffCost: "薪金",
        equipment: "设备",
        services: "服务",
        generalExpenses: "一般开支",
        contingency: "应急费用",
        others: "其他（请说明）",
        totalGrantSought: "申请资助总额",
        expected: "预期学生的学习成果和成品",

        current: "已与小学和中学建立的网络（如有）或吸引学生报名的推广计划",
        networkOrPlan: "网络或计划",
        proposed:
            "质素保证机制建议：（例如：成立质素保证小组、三个月召开一次的质素保证会议、评估学生学习成效、透过会面和问卷以收集学生回馈等）",
        proposedQualityAssuranceMechanism: "质素保证机制建议",
        partC: "乙部：课程内容",
        elaborate:
            "课程审批准则包括但不限于以下三方面：（I）课程需要、（II）课程可行性及（III）预期课程成果和质素保证。",
        programmeNeeds: "（I）课程需要",
        programmeFeasibility: "（II）课程可行性",
        expectedOutcome: "（III）预期课程成果和质素保证",
        rationale: "理念",
        rationale2: "（为何建议举办这个课程？）",
        goal2: "（参考列子：",
        goal3: "目标：进一步发挥资优学生的潜能",
        goal4: "目的：加强资优学生综合和应用跨学科知识与技能的能力，以解决进阶的科学难题；及培养学生面对逆境的正面价值观和态度）",
        hyphen: "-",
        goal5: "加强资优学生综合和应用跨学科知识与技能的能力，以解决进阶的科学难题；及",
        goal6: "培养学生面对逆境的正面价值观和态度）",
        targetBeneficiary2: "（例如：50名中一至中二年级的学生）",
        prerequisite1: "修读条件",
        prerequisite2:
            "（参考例子：学生在学校的科学科／数学科表现卓越，并须具备电脑编程的基础知识。如果没有修读条件，请填「无」。）",
        prerequisite3: "（如果不是，请填写'无'。）",
        selection1: "甄选机制",
        selection2:
            "（例如：学生在申请表上所填报的资料／笔试／会面［请详述］）",
        programmePeriod1: "课程所需时期",
        programmePeriod2: "{{periodExample}}",
        programmePeriodPreparation: "筹备课程所需时期",
        programmePeriodDelivery: "推行课程所需时期",
        preparationPartC: "筹备课程：",
        deliveryPartC: "推行课程：",
        fromPartC: "由",
        toPartC: "至",
        mediumOfInstruction1: "授课语言",
        mediumOfInstruction2: "课程教材：",
        mediumOfInstruction3: "（参考例子：英文）",
        mediumOfInstruction4: "教学 ／ 讨论：",
        mediumOfInstruction5: "（参考例子：以英语为主，辅以广东话）",
        keyImplementation1: "课程推行的主要资料：",
        keyImplementation2:
            "（除筹备期外，课程推行应介乎5-7个月。每个课程的总授课时数不可超过100小时。请阐述课程每阶段的课堂内容、学与教活动、教学模式（网上教学 ／ 面授课堂）、课堂数目等。请详细说明课程的特点及其可行性。如有需要，请在下表插入新行及／或将课程划分为不同阶段。如有需要，可附上证明文件以说明课程的推行计划。）",
        eg1: "参考例子",
        implementationPeriod1: "推行时期",
        implementationPeriod2: "202X年5月至7月",
        implementationPeriod3: "推行时期",
        numContactHours: "授课时数（只需输入数字）",
        numContactHours1: "30",
        content1: "内容 ／ 活动 ／ 模式 ／ 课堂数目",
        content2:
            "（例如:第一阶段：掌握气象学的基础知识，及运用云端计算机技术仿真热带气旋的路径和估算相关的风暴潮：8节［每节3小时］面授课堂［8个有关气象学／数据分析的主题］及6小时计算机编程课堂［合共30小时，为期3个月］）",
        content2_1: "第一阶段（为期3个月，共30小时）",
        content2_2:
            "面授课堂：掌握气象学的基础知识，及运用云端电脑技术模拟热带气旋的路径和估算相关的风暴潮",
        content2_3:
            "包括8节（每节3小时）有关气象学 / 数据分析的课堂及1节6小时电脑编程课堂",
        manpower1: "人力资源计划：",
        manpower2: "（如有需要，请选择「增加」以插入新行。）",
        post1: "职衔",
        post2: "1名课程助理",
        qualification1: "学术资格及 / 或专业资格及 / 或工作经验",
        qualification2:
            "（例如：与科学范畴相关的学士学位或以上学历及具备至少3年筹办以中学生为对象的培训课程的经验）",
        qualification2_1: "与科学范畴相关的学士学位或以上学历及",
        qualification2_2: "具备至少3年筹办以中学生为对象的培训课程的经验",
        roles1: "角色 ／ 职责",
        roles2: "（请说明：全职 ／ 兼职／工作总月数 ／小时）",
        roles3: "（例如，（甲）协助进行课程的日常管理；以及 （乙）协助处理与课程相关的学生事务）",
        roles3_1: "协助进行课程的日常管理及",
        roles3_2: "协助处理与课程相关的学生事务",
        engagementMode1: "参与方式",
        engagementMode2:
            "全职（以月份计算）/ </br>兼职（以小时计算）/ </br>其他（请注明）",
        engagementTime1: "参与时间（月 / 小时）",
        engagementTime2: "6个月",
        engagementMonths: "月",
        engagementHours: "小时",
        budgetPlan1: "财政预算：",
        budgetPlan2: "（请参阅《申请指引》内附件I「财政预算指引」）",
        items: "项目",
        particulars: "详情及理据",
        breakdown: "分项",
        amount: "金额（港币＄）",
        respectiveRoles: "主办机构和协办机构分别的角色（如适用）：",
        role: "角色",
        experience: "资优教育 ／ 人才培育相关经验（如适用）：",
        experience2: "",
        currentNetworks1:
            "已与小学和中学建立的网络（如有）或吸引学生报名的推广计划：",
        currentNetworks2: "（参考例子：举办网上简介会向学校介绍课程）",
        expectedLearningOutcomes1: "预期学生的学习成果及成品：",
        expectedLearningOutcomes2:
            "（参考例子：课程结束后，学生能运用云端运算技术解决高阶科学问题，并在展示会中报告研究成果。）",
        expectedLearningOutcomes3: "预期学生的学习成果及成品",
        proposed2: "质素保证机制建议：",
        proposed3:
            "（建议的机制须包括质素保证小组的组成及订定确保课程质素的措施，例如：评估的形式和次数、导师的训练和课前准备。）",
        partD: "丙部：声明和同意书",
        iHaveRead:
            "本人已阅读并完全明白《申请指引》的内容。本人声明本机构符合申请资格，申办课程亦没有从政府取得其他资助。",
        iCertify:
            "本人声明所提供的资料属实及准确无误。本人明白如提供的资料不正确，本申请将会无效，任何获批的款项将会被停止发放，而所有已获取的款项亦必须退还予资优教育基金。",
        iAgree: "本人已阅读《申请指引》附件II「有关收集个人资料的声明」。本人同意在此申请内提供的资料，可供资优教育基金秘书处和相关政府决策局 ／ 部门处理申请及相关用途。",
        iUnderstand:
            "本人明白，所有申请资优教育基金的建议书将以竞逐的方式处理。在挑选过程中，教育局拥有最终的决定权。",
        nameAndPostTitle: "姓名及职衔",
        postTitleD: "职位名称",
        nameOfOrganisation: "机构名称",
        attachment: "附件",
        attachmentNote: "备注",
        edbDocument: "附件（由教育局上载）",
    },

    select: {
        engagementMode: {
            fullTime: "全职（以月份计算）",
            partTime: "兼职（以小时计算）",
            others: "其他（请注明）",
        },
        targetBeneficiaryLevel: {
            primary: "（i） 高小（小四至小六）",
            secondary: "（ii） 初中（中一至中三）",
            higher: "（iii） 高中（中四至中五）",
            secondaryAndHigher: "（iv） 初中和高中（中一至中五）",
        },
    },

    formContent: {
        themeOfProgrammeOption: {
            stem: "数字教育 / STEAM 相关进阶学习",
            humanities: "人文学科和社会科学研究课程",
            apprenticeship: "实习及企业体验学习课程",
            selfInitiated: "由学生主动提出的研习",
            others: "其他",
        },
    },

    errorMsg: {
        telNo: "电话号码必须为8位数字",
        faxNo: "传真号码必须为8位数字",
        differentFromPartC: "输入数值应与「丙部 - 财政预算 申请资助总额」相同",
        differentFromPartB: "输入数值应与「乙部 - 4.申请资助总额」相同",
        delivery: "请输入一个有效的推行课程",
        numContactHoursTotal: "授课时数总时长不应超过100小时",
        engagementTime: "请输入0-200之间的数字",
        targetBeneficiary: "请输入30-60之间的数字",
    },

    pics: {
        title: "个人资料收集声明",

        h1: "收集个人资料的目的",
        p1_1: "你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
        p1_1_a: "处理、核实及查证就资优教育基金资助的申请；",
        p1_1_b: "就上文（a）项所述申请的处理、核实及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
        p1_1_c: "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；",
        p1_1_d: "培训及发展，包括发出计划／活动邀请、处理发还课程费用申请、 评审提名、奖项和奖学金，以及监察达标进度；",
        p1_1_e: "处理及审核拨款／补助／津贴申请、发放拨款／补助／津贴，以及审计；",
        p1_1_f: "编制统计资料、研究及政府刊物；以及",
        p1_1_g: "执行规则及规例[包括《教育条例》（香港法例第279章）及其附属法例（例如《教育规例》、《补助学校公积金规则》、《津贴学校公积金规则》）和《资助则例》）]。",
        p1_2: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理申请。",

        h2: "可获转移资料者",
        p2_3: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
        p2_3_a: "政府其他政策局及部门，包括教育局，以用于上文第1段所述的用途；",
        p2_3_b: "与本表格相关的学校，以用于上文第1段所述的用途；",
        p2_3_c: "你曾就披露个人资料给予订明同意；以及",
        p2_3_d: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",

        h3: "查阅个人资料",
        p3_4: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向行政主任（资优教育）提出（地址：九龙九龙塘沙福道19号教育局九龙塘教育服务中心东座3楼E328室或电邮：exoge@edb.gov.hk）。",
    },
    dialog: {
        title: "*** 申请程序尚未完成 ***",
        content: `申请程序尚未完成，请继续以下程序：<br />
        <br />
        1. 下载你已提交的申请表并列印；<br />
        2. 请机构负责人在申请表上签名及盖章；以及<br />
        3. 扫描已签名及盖章的申请表，并上载至系统<br />
        <br />
        请注意，我们已向你注册的电子邮件地址发送一封电子邮件，提醒你有关申请程序尚未完成。<br />
        <br />
        当你完成所有申请程序，并当教育局收到你的申请后，你将收到一封确认电子邮件。`,
    },
};

export default Form091SC;
